(function () {
    "use strict";

    // NOTICE: When instantiating a habil-rr-field, only add required=true when really required
    angular.module("app").directive("habilRrField", HabilRrFieldDirective);

    HabilRrFieldDirective.$inject = [];
    function HabilRrFieldDirective() {
        return {
            templateUrl: "@/textField/rr-field.html",
            transclude: true,
            require: { ngModelCtrl: "^ngModel", ngFormCtrl: "^form" },
            scope: {
                required: "=?",
                isReadonly: "=",
                onValidRrEntered: "=?"
            },
            link: link
        };

        function link(scope, _element, _attributes, ctrl) {
            // The NgModelController used for hooking into the angular model and form
            const ngModelCtrl = ctrl.ngModelCtrl;
            const ngForm = ctrl.ngFormCtrl;

            scope.form = ngForm;

            // #region Value handler

            ngModelCtrl.$render = () => {
                scope.ngModel = ngModelCtrl.$viewValue;
            };

            // External changes
            scope.$watch(function () { return scope.ngModel; }, function (newValue, oldValue) {
                // Only set the view value and invoke the callback if a new value is set, otherwise the callback is invoked on load
                if (newValue != oldValue) {
                    ngModelCtrl.$setViewValue(newValue);

                    if (ngModelCtrl.$valid) {
                        invokeCallback();
                    }
                }
            });

            // #endregion

            function invokeCallback() {
                if (angular.isFunction(scope.onValidRrEntered))
                    scope.onValidRrEntered(scope.ngModel);
            }
        }
    }
})();